"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findRemarkWithTargetMvr = exports.findRemarkWithTarget = exports.findNameWithId = exports.filterRemarkOptionsMvr = exports.filterRemarkOptions = exports.targetOptionsMvr = exports.targetOptions = void 0;
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
exports.targetOptions = [
    {
        id: '1.',
        name: 'trmeterentryview/modal/target/options/work'
    },
    {
        id: '2.',
        name: 'trmeterentryview/modal/target/options/ladders'
    },
    {
        id: '3.',
        name: 'trmeterentryview/modal/target/options/machines'
    },
    {
        id: '4.',
        name: 'trmeterentryview/modal/target/options/fall'
    },
    {
        id: '5.',
        name: 'trmeterentryview/modal/target/options/electricity'
    },
    {
        id: '6a.',
        name: 'trmeterentryview/modal/target/options/waste'
    },
    {
        id: '6b.',
        name: 'trmeterentryview/modal/target/options/dust'
    }
];
exports.targetOptionsMvr = [
    {
        id: '1.',
        name: 'trmeterentryview/modal/target/options/working_and_machine_use'
    },
    {
        id: '2.',
        name: 'trmeterentryview/modal/target/options/equipment'
    },
    {
        id: '3.',
        name: 'trmeterentryview/modal/target/options/protection_and_safety_zones'
    },
    {
        id: '4.',
        name: 'trmeterentryview/modal/target/options/driveways_and_walkways'
    },
    {
        id: '5.',
        name: 'trmeterentryview/modal/target/options/order_and_storage'
    }
];
var filterRemarkOptions = function (id) {
    switch (id) {
        case '1.':
            return [
                {
                    id: '1.1',
                    name: 'trmeterentryview/modal/remark/options/helmet'
                },
                {
                    id: '1.2',
                    name: 'trmeterentryview/modal/remark/options/protection'
                },
                {
                    id: '1.3',
                    name: 'trmeterentryview/modal/remark/options/other'
                }
            ];
        case '2.':
            return [
                {
                    id: '2.1',
                    name: 'trmeterentryview/modal/remark/options/bridge'
                },
                {
                    id: '2.2',
                    name: 'trmeterentryview/modal/remark/options/stairs'
                },
                {
                    id: '2.3',
                    name: 'trmeterentryview/modal/remark/options/baseboard'
                },
                {
                    id: '2.4',
                    name: 'trmeterentryview/modal/remark/options/scaffolding'
                },
                {
                    id: '2.5',
                    name: 'trmeterentryview/modal/remark/options/stands'
                },
                {
                    id: '2.6',
                    name: 'trmeterentryview/modal/remark/options/ladders'
                }
            ];
        case '3.':
            return [
                {
                    id: '3.1',
                    name: 'trmeterentryview/modal/remark/options/saws'
                },
                {
                    id: '3.2',
                    name: 'trmeterentryview/modal/remark/options/welders'
                },
                {
                    id: '3.3',
                    name: 'trmeterentryview/modal/remark/options/element'
                },
                {
                    id: '3.4',
                    name: 'trmeterentryview/modal/remark/options/humanlifts'
                },
                {
                    id: '3.5',
                    name: 'trmeterentryview/modal/remark/options/vehiclelifts'
                }
            ];
        case '4.':
            return [
                {
                    id: '4.1',
                    name: 'trmeterentryview/modal/remark/options/railing'
                },
                {
                    id: '4.2',
                    name: 'trmeterentryview/modal/remark/options/opening'
                },
                {
                    id: '4.3',
                    name: 'trmeterentryview/modal/remark/options/trench'
                }
            ];
        case '5.':
            return [
                {
                    id: '5.1',
                    name: 'trmeterentryview/modal/remark/options/center'
                },
                {
                    id: '5.2',
                    name: 'trmeterentryview/modal/remark/options/station-lighting'
                },
                {
                    id: '5.3',
                    name: 'trmeterentryview/modal/remark/options/general-lighting'
                }
            ];
        case '6a.':
        case '6a':
            return [
                {
                    id: '6.1',
                    name: 'trmeterentryview/modal/remark/options/bins'
                },
                {
                    id: '6.2',
                    name: 'trmeterentryview/modal/remark/options/station-order'
                },
                {
                    id: '6.3',
                    name: 'trmeterentryview/modal/remark/options/general-order'
                },
                {
                    id: '6.4',
                    name: 'trmeterentryview/modal/remark/options/scaffolding-order'
                },
                {
                    id: '6.5',
                    name: 'trmeterentryview/modal/remark/options/path'
                }
            ];
        case '6b.':
        case '6b':
            return [
                {
                    id: '6.6',
                    name: 'trmeterentryview/modal/remark/options/dustiness'
                }
            ];
        default:
            return [];
    }
};
exports.filterRemarkOptions = filterRemarkOptions;
var filterRemarkOptionsMvr = function (id) {
    switch (id) {
        case '1.':
            return [
                {
                    id: '1.1',
                    name: 'trmeterentryview/modal/remark/options/safety_and_risk'
                }
            ];
        case '2.':
            return [
                {
                    id: '2.1',
                    name: 'trmeterentryview/modal/remark/options/equipment_and_lifts'
                },
                {
                    id: '2.2',
                    name: 'trmeterentryview/modal/remark/options/small_equipment'
                },
                {
                    id: '2.3',
                    name: 'trmeterentryview/modal/remark/options/scaffolding_workbenches_etc'
                },
                {
                    id: '2.4',
                    name: 'trmeterentryview/modal/remark/options/electrification'
                },
                {
                    id: '2.5',
                    name: 'trmeterentryview/modal/remark/options/lighting'
                },
                {
                    id: '2.6',
                    name: 'trmeterentryview/modal/remark/options/emulsion_device'
                },
                {
                    id: '2.7',
                    name: 'trmeterentryview/modal/remark/options/rescue_container'
                }
            ];
        case '3.':
            return [
                {
                    id: '3.1',
                    name: 'trmeterentryview/modal/remark/options/fall_protection'
                },
                {
                    id: '3.2',
                    name: 'trmeterentryview/modal/remark/options/landslide_danger'
                },
                {
                    id: '3.3',
                    name: 'trmeterentryview/modal/remark/options/machine_safety_zones'
                }
            ];
        case '4.':
            return [
                {
                    id: '4.1',
                    name: 'trmeterentryview/modal/remark/options/external_and_light_traffic'
                },
                {
                    id: '4.2',
                    name: 'trmeterentryview/modal/remark/options/worksite_roads'
                },
                {
                    id: '4.3',
                    name: 'trmeterentryview/modal/remark/options/walkways'
                },
                {
                    id: '4.4',
                    name: 'trmeterentryview/modal/remark/options/rescue_arrangement'
                }
            ];
        case '5.':
            return [
                {
                    id: '5.1',
                    name: 'trmeterentryview/modal/remark/options/general_order'
                },
                {
                    id: '5.2',
                    name: 'trmeterentryview/modal/remark/options/waste'
                },
                {
                    id: '5.3',
                    name: 'trmeterentryview/modal/remark/options/dangerous_substances'
                },
                {
                    id: '5.4',
                    name: 'trmeterentryview/modal/remark/options/air_and_dust'
                }
            ];
        default:
            return [];
    }
};
exports.filterRemarkOptionsMvr = filterRemarkOptionsMvr;
var findNameWithId = function (id, array) {
    var option = array.find(function (item) {
        return item.id === id;
    });
    if (option) {
        return (0, translation_1.getLocalization)(option.name);
    }
    else {
        return '';
    }
};
exports.findNameWithId = findNameWithId;
var findRemarkWithTarget = function (remarkId, targetId) {
    var remarks = (0, exports.filterRemarkOptions)(targetId);
    var option = remarks.find(function (item) {
        return item.id === remarkId;
    });
    if (option) {
        return (0, translation_1.getLocalization)(option.name);
    }
    else {
        return '';
    }
};
exports.findRemarkWithTarget = findRemarkWithTarget;
var findRemarkWithTargetMvr = function (remarkId, targetId) {
    var remarks = (0, exports.filterRemarkOptionsMvr)(targetId);
    var option = remarks.find(function (item) {
        return item.id === remarkId;
    });
    if (option) {
        return (0, translation_1.getLocalization)(option.name);
    }
    else {
        return '';
    }
};
exports.findRemarkWithTargetMvr = findRemarkWithTargetMvr;
